import { lazy, Suspense } from "react";

const Panels = lazy(() => import("./InsightsPanels").then((m) => ({ default: m.InsightsPanels })));

const MoreInsights = (props) => (
  <Suspense fallback={null}>
    <Panels {...props} />
  </Suspense>
);

// One entry per section of a project's Analytics page; each renders the
// panels that belong there with the page's own card (``Panel``).
const SECTIONS = ["overview", "quality", "readiness", "people", "delivery"];

export const insightsPanels = SECTIONS.map((section) => ({
  key: `more-insights-${section}`,
  section,
  component: (props) => <MoreInsights {...props} section={section} />,
}));
